import { api } from 'api/api';
import { HomePageResponseViewModel } from 'types/home-page';
import { GetHomePagesRequest, UpdateHomePageRequest, CreateHomePageRequest, HomePagesResponse } from './types';
import { parametrizeURL } from 'api/utils';

export const HomePage_URL = 'HomePage' as const;
export const GET_HomePageS_URL = `${HomePage_URL}/GetAllAsync` as const;
export const ADD_HomePage_URL = `${HomePage_URL}/AddAsync` as const;
export const UPDATE_HomePage_URL = `${HomePage_URL}/UpdateAsync/{HomePageId}` as const;
export const SET_ACTIVE_PAGE_URL = `${HomePage_URL}/SetActiveAsync/{id}` as const;
export const GET_CURRENT_HOMEPAGE_URL = `${HomePage_URL}/GetCurrentAsync` as const;

export const readHomePageById = (params: { id: string }) =>
    api.get<HomePageResponseViewModel>(HomePage_URL, { params });

export const deleteHomePageById = (data: { id: string }) => api.delete<void>(HomePage_URL, { data });

export const readHomePages = (params: GetHomePagesRequest) => api.get<HomePagesResponse>(GET_HomePageS_URL, { params });

export const readCurrentHomePage = () => api.get<HomePageResponseViewModel>(GET_CURRENT_HOMEPAGE_URL);

export const createHomePage = (body: CreateHomePageRequest) =>
    api.post<HomePageResponseViewModel>(ADD_HomePage_URL, body);

export const createActiveHomePage = (id: string) =>
    api.post<HomePageResponseViewModel>(parametrizeURL(SET_ACTIVE_PAGE_URL, { id }));

export const replaceHomePage = (body: UpdateHomePageRequest, HomePageId: string) =>
    api.post<HomePageResponseViewModel>(parametrizeURL(UPDATE_HomePage_URL, { HomePageId }), body);
